export default __webpack_public_path__ + "static/media/co__dash__op_dark.158ef6ec.png";